import type {PromotionCycle} from '../../types';

import DiscountSection from '../common/DiscountSection/DiscountSection';
import EditableDiscountCard from './components/EditableDiscountCard/EditableDiscountCard';

type QueuedDiscountsProps = {
  cycles: PromotionCycle[];
  onItemClick: (cycleId: string | number) => void;
};

const QueuedDiscounts: React.FC<QueuedDiscountsProps> = ({cycles, onItemClick}) => {
  return (
    <DiscountSection title="تخفیف در صف اجرا">
      {cycles.map((cycle) => (
        <EditableDiscountCard
          key={cycle.cycle_id}
          cycle={cycle}
          onClick={() => onItemClick(cycle.cycle_id)}
        />
      ))}
    </DiscountSection>
  );
};

export default QueuedDiscounts;
